<template>
  <div class="tableDetail">
    <el-row>
      <el-col>
        <el-form class="form">
          <el-form-item label="发起机构">
            <patientTree @input="input"></patientTree>
          </el-form-item>
          <el-form-item label="患者姓名">
            <el-input v-model="listQuery.patientName"></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getListMyApply">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="reportExportToExcel"
              >导出</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table v-loading="listLoading" :data="manageList" fit highlight-current-row>
          <el-table-column align="center" label="申请时间">
            <template slot-scope="scope">
              <span>{{ scope.row.applyCodiagTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.patientName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.gender }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="年龄">
            <template slot-scope="scope">
              <span>{{ getAge(scope.row.birthday) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="电话">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="联系人">
            <template slot-scope="scope">
              <span>{{ scope.row.contactName }}</span>
            </template>
          </el-table-column>
 
          <el-table-column align="center" label="联系人电话">
            <template slot-scope="scope">
              <span>{{ scope.row.contactPhone }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="发起人">
            <template slot-scope="scope">
              <span>{{ scope.row.applyDoctorName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="发起机构">
            <template slot-scope="scope">
              <span>{{ scope.row.applyHospital }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="诊断">
            <template slot-scope="scope">
              <el-button type="primary" @click="diagnose(scope.row)">诊断详情</el-button>
              <diagnoseDetailDialog v-if="diagnoseVisiaable" ref="diagnoseRef"></diagnoseDetailDialog>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="patientsDetail(scope.row)">查看</el-button>
              <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
          @pagination="turnToPage" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getListMyApply, turnToMyApply, getSearchList,reportToExcel } from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import patientDetail from "@/views/patient/patientDetail";
import diagnoseDetailDialog from "./pressureRecordDialogs/diagnoseDetailDialog.vue";
import patientTree from '@/components/selectTree';
import { Loading } from "element-ui";
import moment from "moment";

export default {
  components: { patientDetail, diagnoseDetailDialog, patientTree, Pagination },
  data() {
    return {
      valueData: null,
      manageList: [],
      listLoading: false,
      patientDetailVisible: false,
      diagnoseVisiaable: false,
      total: 0,
      data: null,
      loadingOptions: {
        text: "正在导出...",
        background: "rgba(0, 0, 0, 0.6)",
      },
      listQuery: {
        codiagServiceName: '高血压协诊',
        pageNum: 1,
        pageSize: 10,
        token: this.$store.getters.token,
        patientName: "",
        managerHospitals: [],
        startTime: null,
        endTime: null
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      exportBody: {
        url: "/business/patientCoDiagnosis/listMyApply",
        headers: ['申请时间', '姓名', '性别', '年龄', '电话', '联系人', "联系人电话", "发起人", "发起机构"],
        keys: ['applyCodiagTime', 'patientName', 'gender', 'birthday', 'phone', 'contactName', "contactPhone", "applyDoctorName", "applyHospital"],
        body: null,
      },
    }

  },
  created() {
    this.getListMyApply();
  },
  methods: {
    //查询结果导出
    reportExportToExcel() {
      console.log(
        "查询结果导出",
        `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );

      let loadingInstance = Loading.service(this.loadingOptions);

      this.exportBody.url = '/business/patientCoDiagnosis/listMyApply?page=' + this.listQuery.pageNum + '&pageSize=' + this.listQuery.pageSize;

      this.exportBody.body = this.listQuery;
      console.log("导出表格请求body：",this.exportBody);

      reportToExcel(this.exportBody)
        .then((res) => {
          console.log("查询表格导出====", res);

          this.$nextTick(() => {
            loadingInstance.close();
          });

          let blob = new Blob([res], { type: "application/force-download" });
          console.log(blob);
          let fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onload = (e) => {
            let a = document.createElement("a");
            a.download = `高血压协诊管理-我发起的${moment(new Date()).format(
              "YYYYMMDDHHmm"
            )}.xlsx`;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        })
        .catch((error) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });

          console.log(error);

          this.$message({
            message: "导出失败",
            type: "error",
          });
        });
    },
    // 选取机构
    input(value) {
      this.listQuery.managerHospitals = value;
    },
    // 获取我发起的列表
    getListMyApply() {
      this.listLoading = true;
      if(this.valueData) {
        this.listQuery.startTime = this.getParseDate(this.valueData[0], 1);
        this.listQuery.endTime = this.getParseDate(this.valueData[1], 2);
      } else {
        this.listQuery.startTime = null;
        this.listQuery.endTime = null;
      }
      getListMyApply(this.listQuery).then(res => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
          console.log("获取成功");
        }
      })
    },
    // 計算年齡
    getAge(birthday) {
      if (birthday == null) return "";
      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    // 跳转诊断列表
    diagnose(rowValue) {
      this.diagnoseVisiaable = true;
      this.$nextTick(() => {
        this.$refs.diagnoseRef.init(rowValue);
      })
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      let params = {
        healthNo: row.healthNo
      }
      getSearchList(params).then((res) => {
        if (res.msg == "success") {
          console.log("========", res, row)
          var data = res.data.records[0];
          this.patientDetailVisible = true;
          this.$nextTick(() => {
            this.$refs["PatientDetailRef"].init(data);
          });
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.listLoading = true;
      if(this.valueData) {
        this.listQuery.startTime = this.getParseDate(this.valueData[0], 1);
        this.listQuery.endTime = this.getParseDate(this.valueData[1], 2);
      }
      turnToMyApply(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  display: flex;

  ::v-deep {
    .el-form-item {
      margin-left: 5px;
    }

    .el-form-item__content {
      display: flex;
    }
  }
}
</style>